import $P from 'plugins/kapida/platformConfigs/integrationMaps/signin';
import { objectSelector } from 'theme/utils';

class SignInSmsVerification {
  constructor(data) {
    const { expireDate } = data;
    this.expireDate = expireDate;
  }
}

export const signInSmsVerificationMapper = (item) => {
  return new SignInSmsVerification({
    expireDate: objectSelector(item, $P.SIGN_IN_SMS_CODE_EXPIRE_DATE),
  });
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/signInSmsVerification.js